<template>
    <div class="survey-note-form-generated-text"
         v-if="draftSurveyNote.text">

        <div class="input-group-generated"
             v-for="(scoreName,i) in scoreNames" :key="i"
             :class="{excluded: !includeGenerated[scoreName]}">
            <b-form-checkbox v-if="generated[scoreName]"
                             v-model="includeGenerated[scoreName]"
                             :value="true"
                             :unchecked-value="false">
                {{ generated[scoreName] }}
            </b-form-checkbox>
        </div>

    </div>
</template>

<script>

export default {
    name: 'SurveyNoteFormGeneratedText',
    props: {
        scoreNames: Array
    },
    computed: {
        draftSurveyNote() {
            return this.$store.state.draftSurveyNote
        },
        includeGenerated() {
            return this.draftSurveyNote.text.includeGenerated
        },
        generated() {
            return this.draftSurveyNote.text.generated
        }
    },
}
</script>

<style lang="scss">
.survey-note-form-generated-text {

    .input-group-generated {
        label {
            text-transform: none !important;
            font-size: 1rem;
        }

        &.excluded {
            label {
                color: #ccc;
            }
        }
    }

}
</style>
